import React from 'react'
import { DialogContent, Dialog as MuiDialog } from '@mui/material'
import { useDocPreview } from 'hooks/useDocPreview'
import EditPreview from 'components/EditPreview'
import UploadHeader from 'components/UploadHeader'
import { MESSAGES } from '../messages/messages'

const EditPreviewDialog = () => {
    const { clearEditPreview, isEditPreview } = useDocPreview()

    return (
        <>
            {isEditPreview && (
                <MuiDialog
                    fullScreen
                    open={isEditPreview}
                    onClose={clearEditPreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    data-testid="edit-preview-dialog"
                    sx={{
                        color: 'common.fordBlue.main',
                        textAlign: 'left',
                        zIndex: 3000,
                        '.MuiDialog-paper': {
                            backgroundColor: 'background.default'
                        },
                        margin: 0
                    }}
                >
                    <UploadHeader headerName={MESSAGES.edit} clickHandler={clearEditPreview} />

                    <DialogContent
                        sx={{
                            backgroundColor: 'background.surface.main',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            position: 'relative',
                            p: 0
                        }}
                    >
                        <EditPreview />
                    </DialogContent>
                </MuiDialog>
            )}
        </>
    )
}

export default EditPreviewDialog
